export const GET_GIFT = 'v2/spin/customer-history/spin';
export const GET_GIFT_LIST = 'v2/spin/get-gifts';
export const GET_TURNS = 'v2/spin/check-turns';
export const CHECK_PHONE_USER = 'v2/spin/check-user';
export const GET_LIST_CLASS = 'v2/spin/get-class';
export const GET_MY_GIFT = 'v2/spin/customer-history/get-spin-history-by-phone';
export const GET_HISTORY_GIFT = 'v2/spin/customer-history';
export const INFORMATION_SPIN = 'v2/spin/get-time-reward-program'
export const GET_NAME_USER = 'v2/spin/customers/get-customer-by-phone'